<template>
  <div class="view-container">
    <div class="card staff-table">
      <div class="card-header card-header-divider">
        <div class="card-title">
          {{ getRight("usersList") ? "Пользователи" : "Сотрудники" }}
        </div>
        <div class="tools">
          <div class="btn btn-accent" @click="showLoadForm = !showLoadForm">
            Загрузить список сотрудников в формате excel
          </div>
          <div class="btn btn-accent add_user_btn" @click="showNewStaffForm = true">
            {{
              getRight("usersList")
                ? "Добавить пользователя"
                : "Добавить сотрудника"
            }}
          </div>
        </div>
      </div>
      <div class="card-body">
        <excel-load-row v-if="showLoadForm" class="my-10" />
        <staff-table />
      </div>
    </div>

    <new-staff-form
        v-if="showNewStaffForm"
        :open="showNewStaffForm"
        :is-admin-action="true"
        @close="showNewStaffForm = false"
        @userCreated="fetchUsers"
    />
  </div>
</template>

<script>
import ExcelLoadRow from "@/feature/users/ExcelLoadRow.vue";
import StaffTable from "@/feature/users/StaffTable.vue";
import NewStaffForm from "@/views/Staff/NewStaffForm.vue";
import { ref } from "@vue/reactivity";
import {useStore} from "vuex";
import useCheckRights from "../../mixins/useCheckRights";

export default {
  components: { StaffTable, ExcelLoadRow, NewStaffForm },
  name: "staff-page",
  setup() {
    const store = useStore();
    const showLoadForm = ref(false);
    const showNewStaffForm = ref(false);
    const { getRight } = useCheckRights();

    const fetchUsers = () => {
      store.dispatch("users/getUsersBySearch", {
        perPage: 15,
        page: 1,
        name: "",
        email: "",
        role: "",
      });
    };

    return {
      showLoadForm,
      showNewStaffForm,
      getRight,
      fetchUsers,
    };
  },
};
</script>

<style>
.btn-accent {
  margin-left: 15px;
}
.tools .add_user_btn {
  line-height: inherit;
}
</style>
